/** Adapt stored/config filters to the shared SSR and client backend mapper. */
import {
  emptyParsedSearchParams,
  normalizeFilterParams,
  type ParsedSearchParams,
} from '@/lib/search-filters';

export function filterParamsToParsed(raw: unknown): ParsedSearchParams {
  const f = normalizeFilterParams(raw);
  const { city, Bundesland, naceCodes, industries, ...rest } = f;
  return {
    ...emptyParsedSearchParams(),
    ...rest,
    cities: city,
    bundesland: Bundesland,
    naceCodeParams: naceCodes,
    industryParams: industries,
  };
}
